import { ErrorHandler, Injectable } from '@angular/core';
import { LoggingService } from '../logging-service/logging-service.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService extends ErrorHandler {

  constructor(private myLoggingService: LoggingService) {
    super();
  }

  override handleError(error: Error) {
    console.log(error);
    this.myLoggingService.logException(error); // Manually log exception
  }
}
